import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Typography, Spin, Dropdown, Button, Input } from 'antd';
import { CustomImage, CustomPageHeader, CustomTable , useText} from '@src/components';
import { useLang } from '@src/context';
import { formatPlate } from '@src/utils/utils';
import search from '@src/assets/icons/ticketcar/search-normal.svg';
import iconSetting from '@src/assets/icons/icon-settings.svg';
import filterButton from '@src/assets/icons/icon-task-square.svg';
import '@src/styles/demands/demands.scss';
import { getVehicleActivityLogs } from '@src/store/slice/demandsStore/demandsSlice';
import dayjs from '@src/utils/day';
import { SearchOutlined } from '@ant-design/icons';
import { debounce } from 'lodash/function';
import CustomIconComponent from '@src/components/CustomIconComponent';
import CustomFilterCollapse from '@src/components/CustomFilterCollapse';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import icnUp from '@src/assets/icons/icn-up.svg';
import icnDown from '@src/assets/icons/icn-down.svg';

const { Text } = Typography;

const Demands = (props) => {
  const dispatch = useDispatch();
  const { language } = useLang();
  const {
    demandList = [],
    requestorList = null,
    requestTypeList = null,
    statusList = null,
    providerList = null,
    deviceTypeList = null,
    loading,
    pagedProperty,
  } = useSelector((state) => state.demands);
  const { isAdmin } = useSelector((state) => state.auth);
  const { selectedUserId } = useSelector((state) => state.user);
  const [filteredText, setFilteredText] = useState('');
  const [searchedText, setSearchedText] = useState('');
  const [filteredPlateQuery, setFilteredPlateQuery] = useState('');
  const [requestor, setRequestor] = useState(null);
  const [requestTypes, setRequestTypes] = useState(null);
  const [status, setStatus] = useState(null);
  const [devices, setDevices] = useState(null);
  const [providers, setProviders] = useState(null);
  const [checkedRequestor, setCheckedRequestor] = useState([]);
  const [checkedRequestTypes, setCheckedRequestTypes] = useState([]);
  const [filteredDate, setFilteredDate] = useState('');
  const [checkedDevices, setCheckedDevices] = useState([]);
  const [checkedProviders, setCheckedProviders] = useState([]);
  const [checkedStatus, setCheckedStatus] = useState([]);
  const [panels, setPanels] = useState([]);
  const [openSearchBar, setOpenSearchBar] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [disableTicketCarPage, setDisableTicketCarPage] = useState(true);
  const { menus } = useSelector((state) => state.menus);
  const isMobil = useMediaQuery({ query: '(max-width: 768px)' });
  const [columns, setColumns] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [requestFilter, setRequestFilter] = useState(null);
  const inputRef = useRef(null);
  const history = useHistory();

  const vehicleTransactionRequests = useText('vehicleTransactionRequests');
  const requests = useText('requests');
  const provider2 = useText('provider2');
  const statusText = useText('status');
  const licensePlate = useText('licensePlate');
  const requestDate2 = useText('requestDate2');
  const requestOwner2 = useText('requestOwner2');
  const requestNo2 = useText('requestNo2');
  const requestType2 = useText('requestType2');
  const deviceType4 = useText('deviceType4');
  const filter2 = useText('filter2');
  const requestOwner3 = useText('requestOwner3');
  const requestType3 = useText('requestType3');
  const deviceType5 = useText('deviceType5');
  const provider = useText('provider');
  const requestDate3 = useText('requestDate3');
  const status3 = useText('status3');

  useEffect(() => {
    if (menus && !isAdmin) {
      if (menus.filter((item) => item.text?.includes('TICKET CAR')).length < 1) {
        setDisableTicketCarPage(false);
      }
    }
  }, [menus]);

  useEffect(() => {
    let tempColumns = [
      {
        title: '#',
        dataIndex: 'idx',
        key: 'idx',
        fixed: 'left',
        align: 'center',
        width: isMobil ? 20 : 40,
        height: 50,
        className: 'custom-id-column',
      },
      {
        title: licensePlate,
        dataIndex: 'plate',
        key: 'plate',
        align: 'left',
        width: 80,
        height: 50,
        className: 'custom-plate-column',
        render: (text) => formatPlate(text),
      },
    ];
    if (isMobil) {
      tempColumns = tempColumns.concat([
        {
          title: provider2,
          dataIndex: 'provider',
          key: 'provider',
          align: 'left',
          width: 74,
          height: 50,
          render: (_, record) => {
            const vouId = record.providerType;
            const IconComponent = CustomIconComponent({ providerType: vouId });
            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {IconComponent && (
                  <img
                    src={IconComponent}
                    alt={record.provider}
                    style={{ width: 24, height: 24 }}
                  />
                )}
              </div>
            );
          },
        },
        {
          title: statusText,
          dataIndex: 'statusDescription',
          key: 'statusDescription',
          align: 'left',
          width: 124,
          height: 50,
          render: (_, record) => (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row',
              }}
            >
              <span
                className={`${
                  record?.statusDescription === 'İşlemde'
                    ? 'demand-status-process-div'
                    : 'demand-status-end-div'
                }`}
              >
                {record?.statusDescription}
              </span>
              <CustomImage
                style={{ width: 24, height: 24, marginLeft: 5, flexGrow: 0, cursor: 'pointer' }}
                src={expandedRowKeys?.includes(record.id) ? icnUp : icnDown}
                onClick={() => handleExpand(record.id)}
              />
            </div>
          ),
        },
      ]);
    } else {
      tempColumns = tempColumns.concat([
        {
          title: requestDate2,
          dataIndex: 'requestTime',
          key: 'requestTime',
          align: 'left',
          width: 90,
          height: 50,
          render: (text) => dayjs(text).format('DD/MM/YYYY HH:mm'),
        },
        {
          title: requestOwner2,
          dataIndex: 'requestor',
          key: 'requestor',
          align: 'left',
          width: 80,
          height: 50,
        },
        {
          title: requestNo2,
          dataIndex: 'id',
          key: 'id',
          fixed: 'left',
          align: 'left',
          width: 70,
          height: 50,
          className: 'custom-id-column',
        },
        {
          title: requestType2,
          dataIndex: 'requestType',
          key: 'requestType',
          align: 'left',
          width: 90,
          height: 50,
        },
        {
          title: deviceType4,
          dataIndex: 'deviceTypeLabel',
          key: 'deviceTypeLabel',
          align: 'left',
          width: 90,
          height: 50,
        },
        {
          title: provider2,
          dataIndex: 'provider',
          key: 'provider',
          align: 'left',
          width: 76,
          height: 50,
          render: (_, record) => {
            const vouId = record.providerType;
            const IconComponent = CustomIconComponent({ providerType: vouId });
            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {IconComponent && (
                  <img
                    src={IconComponent}
                    alt={record.provider}
                    style={{ width: 24, height: 24, marginRight: 8 }}
                  />
                )}
              </div>
            );
          },
        },
        {
          title: statusText,
          dataIndex: 'statusDescription',
          key: 'statusDescription',
          align: 'left',
          width: 96,
          height: 50,
          render: (statusDescription) => (
            <span
              className={`${
                statusDescription === 'İşlemde'
                  ? 'demand-status-process-div'
                  : 'demand-status-end-div'
              }`}
            >
              {statusDescription}
            </span>
          ),
        },
      ]);
    }
    setColumns(tempColumns);
  }, [isMobil, expandedRowKeys]);

  const handleExpand = useCallback((rowKey) => {
    setExpandedRowKeys((expandedRows) => {
      if (expandedRows.includes(rowKey)) {
        return expandedRows.filter((id) => id !== rowKey);
      }
      return [...expandedRows, rowKey];
    });
  }, []);

  useEffect(() => {
    if (!disableTicketCarPage && history) {
      history.push('/dashboard');
    }
  }, [disableTicketCarPage]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [filteredText]);

  useEffect(() => {
    if (searchedText?.length > 2 && searchedText.replace(/\s+/g, '').length > 2) {
      const filter = { plate: searchedText.replace(/\s+/g, '') };
      clickFilter(filter);
      setFilteredPlateQuery(searchedText.replace(/\s+/g, ''));
    }
  }, [searchedText]);

  const fetchVehicleListData = async (flag = true) => {
    let req = { pageNumber: pagination.current, pageSize: pagination.pageSize };
    if (isAdmin && selectedUserId) {
      req.customerId = parseInt(selectedUserId, 10);
    }
    if (requestFilter && flag) {
      req.filter = requestFilter;
    }
    await dispatch(getVehicleActivityLogs(req));
  };

  useEffect(() => {
    fetchVehicleListData();
  }, [dispatch, pagination, selectedUserId, language]);

  useEffect(() => {
    try {
      if (requestorList) {
        setRequestor(
          Object.entries(requestorList).map(([key, value]) => ({
            key: key,
            value: value,
          })),
        );
      }
    } catch (error) {
      console.error(error);
    }
  }, [requestorList]);

  useEffect(() => {
    try {
      if (requestTypeList) {
        setRequestTypes(
          Object.entries(requestTypeList).map(([key, value]) => ({
            key: key,
            value: value,
          })),
        );
      }
    } catch (error) {
      console.error(error);
    }
  }, [requestTypeList]);

  useEffect(() => {
    try {
      if (statusList) {
        setStatus(
          Object.entries(statusList).map(([key, value]) => ({
            key: key,
            value: value,
          })),
        );
      }
    } catch (error) {
      console.error(error);
    }
  }, [statusList]);

  useEffect(() => {
    try {
      if (providerList) {
        setProviders(
          Object.entries(providerList).map(([key, value]) => ({
            key: key,
            value: value,
          })),
        );
      }
    } catch (error) {
      console.error(error);
    }
  }, [providerList]);

  useEffect(() => {
    try {
      if (deviceTypeList) {
        setDevices(
          Object.entries(deviceTypeList).map(([key, value]) => ({
            key: key,
            value: value,
          })),
        );
      }
    } catch (error) {
      console.error(error);
    }
  }, [deviceTypeList]);

  const dataSourceWithId = demandList.map((item, index) => ({
    ...item,
    idx: index + 1, // index + 1 kullanarak sıfırdan başlamayan bir id ataması yapıyoruz
  }));

  useEffect(() => {
    setPanels([
      {
        list: checkedRequestor,
        setList: setCheckedRequestor,
        text: requestOwner3,
        initialList: requestor,
        key: 'requestor',
      },
      {
        list: checkedRequestTypes,
        setList: setCheckedRequestTypes,
        text: requestType3,
        initialList: requestTypes,
        key: 'requestTypes',
      },
      {
        list: checkedDevices,
        setList: setCheckedDevices,
        text: deviceType5,
        initialList: devices,
        key: 'devices',
      },
      {
        list: checkedProviders,
        setList: setCheckedProviders,
        text: provider,
        initialList: providers,
        key: 'providers',
      },
      {
        setList: setFilteredDate,
        text: requestDate3,
        key: 'requestTime',
        date: true,
        defaultValue: filteredDate,
      },
      {
        list: checkedStatus,
        setList: setCheckedStatus,
        text: status3,
        initialList: status,
        key: 'status',
      },
    ]);
  }, [
    status,
    checkedRequestTypes,
    checkedDevices,
    checkedProviders,
    checkedStatus,
    checkedRequestor,
    filteredDate,
  ]);

  const clearDemands = () => {
    try {
      setRequestFilter(null);
      setCheckedRequestor([]);
      setCheckedDevices([]);
      setCheckedProviders([]);
      setCheckedStatus([]);
      setCheckedRequestTypes([]);
      setFilteredText('');
      setSearchedText('');
      setFilteredPlateQuery('');
      setFilteredDate('');
      fetchVehicleListData(false);
    } catch (error) {
      console.error(error);
    }
  };

  const clickFilter = async (tempFilter = null) => {
    try {
      const filter = tempFilter.plate
        ? tempFilter
        : {
            requestorIds: checkedRequestor?.map((it) => parseInt(it, 10)),
            deviceTypeIds: checkedDevices?.map((it) => parseInt(it, 10)),
            providerIds: checkedProviders?.map((it) => parseInt(it, 10)),
            statusIds: checkedStatus?.map((it) => parseInt(it, 10)),
            requestTypeIds: checkedRequestTypes?.map((it) => parseInt(it, 10)),
            startTime: filteredDate?.start,
            endTime: filteredDate?.end,
          };

      setRequestFilter(filter);
      let req = { pageNumber: 1, pageSize: pagination.pageSize, filter };
      if (isAdmin && selectedUserId) {
        req.customerId = parseInt(selectedUserId, 10);
      }
      await dispatch(getVehicleActivityLogs(req));
    } catch (error) {
      console.error(error);
    }
  };

  const listenClickCheckbox = (setList, tempList) => {
    setList(tempList);
  };

  function FilterMenu() {
    return (
      <div className="custom-filter-menu">
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <span className="custom-filter-menu-filtrele">{filter2}</span>
          <button onClick={clearDemands} className="custom-filter-menu-clear">
            <Text t="clean" /></button>
        </div>

        <CustomFilterCollapse panels={panels} listenClickCheckbox={listenClickCheckbox} />

        <Button
          type="primary"
          onClick={clickFilter}
          block
          style={{
            width: '224px',
            height: '40px',
            flexGrow: 0,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 12,
            marginTop: 28,
            marginRight: 2,
            marginLeft: 0,
            marginBottom: 0,
            paddingTop: 8,
            paddingRight: 12,
            paddingBottom: 8,
            paddingLeft: 12,
            borderWidth: 0,
            borderRadius: 6,
            backgroundColor: '#00a483',
          }}
          className="custom-filter-menu-filter-button"
        >
          <CustomImage src={filterButton} /> {filter2}
        </Button>
      </div>
    );
  }

  const handlePageChange = (page, pageSize) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      current: page?.current,
    }));
  };

  const handleSearch = (value) => {
    setSearchedText(value);
  };

  const debouncedSearch = useCallback(debounce(handleSearch, 1000), []);

  const onInputChange = (e) => {
    const value = e.target.value;
    if (value?.length === 0) {
      try {
        if (filteredPlateQuery?.length > 1) {
          setFilteredPlateQuery('');
          fetchVehicleListData(false);
        }
      } catch (error) {
        console.error(error);
      }
      setOpenSearchBar(!openSearchBar);
    }
    setFilteredText(value);
    debouncedSearch(value);
  };

  function expandedRowRender(record) {
    return (
      <div className="new-car-demands-expand">
        <div className="vehicle-management-expand-line" style={{ height: 160 }} />
        <div
          className="vehicle-management-expand-main-div "
          style={{ marginBottom: 5, height: 140 }}
        >
          <div className="vehicle-management-expand-div">
            <span className="vehicle-management-expand-head" style={{ width: 80 }}>
              <Text t="requestDate2" />
            </span>
            <span className="vehicle-management-expand-text">
              {dayjs(record.requestTime).format('DD/MM/YYYY HH:mm')}
            </span>
          </div>
          <div className="vehicle-management-expand-div">
            <span className="new-car-demands-expand-head" style={{ width: 80 }}>
              <Text t="requestOwner" />
            </span>
            <span className="vehicle-management-expand-text">{record.requestor}</span>
          </div>
          <div className="vehicle-management-expand-div">
            <span className="new-car-demands-expand-head" style={{ width: 80 }}>
              <Text t="requestType" />
            </span>
            <span className="vehicle-management-expand-text">{record?.requestType}</span>
          </div>
          <div className="vehicle-management-expand-div">
            <span className="new-car-demands-expand-head" style={{ width: 80 }}>
              <Text t="deviceType3" />
            </span>
            <span className="vehicle-management-expand-text">{record?.deviceTypeLabel}</span>
          </div>
        </div>
      </div>
    );
  }

  const content = () => {
    return loading.demandList ? (
      <div className="loading-container" style={{ textAlign: 'center', padding: '250px' }}>
        <Spin size="large" className="custom-spin" />
      </div>
    ) : (
      <Card
        title={requests}
        className="balance-list-container"
        headStyle={{ fontFamily: 'UbuntuRegular', fontSize: '18px', fontWeight: 'bolder' }}
        extra={
          <div className="balance-tools" style={{ width: !openSearchBar ? 144 : 200 }}>
            {!openSearchBar && (
              <div className="header-notification" style={{ backgroundColor: 'transparent' }} />
            )}
            {openSearchBar ? (
              <Input
                ref={inputRef}
                id="demandsFilterSearch"
                name="demandsFilterSearch"
                type="text"
                placeholder="Plaka"
                prefix={<SearchOutlined />}
                className="custom-filter-menu-search no-margin"
                value={filteredText}
                onChange={onInputChange}
              />
            ) : (
              <div className="header-notification">
                <CustomImage
                  style={{ cursor: 'pointer' }}
                  src={search}
                  onClick={() => setOpenSearchBar(!openSearchBar)}
                />
              </div>
            )}

            <div className="header-notification">
              <Dropdown overlay={<FilterMenu />} trigger={['click']}>
                <Button
                  type="text"
                  icon={<CustomImage src={iconSetting} />}
                  style={{
                    borderRadius: '0',
                    padding: '0',
                    backgroundColor: 'transparent',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 'auto',
                    height: 'auto',
                  }}
                />
              </Dropdown>
            </div>
          </div>
        }
      >
        <CustomTable
          data-testid="table-test-id"
          pagination={
            pagedProperty?.totalItems < 11
              ? false
              : {
                  pageSize: pagedProperty?.pageSize,
                  total: pagedProperty?.totalItems,
                  current: pagedProperty?.currentPage,
                  className: 'demands-list-pagination',
                }
          }
          onPageChange={handlePageChange}
          dataSource={dataSourceWithId}
          columns={columns}
          className="babs-list-table"
          rowKey={(record) => record.id}
          expandedRowKeys={expandedRowKeys}
          expandable={{
            showExpandColumn: false,
            expandIconColumnIndex: 17,
            onExpand: (expanded, record, key) =>
              expandedRowKeys === key ? setExpandedRowKeys(null) : setExpandedRowKeys([key]),
            expandedRowRender: expandedRowRender,
          }}
        />
      </Card>
    );
  };

  return (
    <CustomPageHeader
      data-testid="demands-test-id"
      title={isAdmin ? null : vehicleTransactionRequests}
      showBreadCrumb={!isAdmin}
      showHelpButton={!isAdmin}
      adminCustomHeaderContent={isAdmin ? 'custom-header-content-subpage' : ''}
      routes={['ticketCarHeader']}
    >
      {content()}
    </CustomPageHeader>
  );
};

export default Demands;
